module.exports = __webpack_public_path__ + "media/images/active_pin-76d3f4eb54f0f36bc8db92b6f290a642.svg";